import modalService from '~/@common/services/modal.service'
import { InitialStudentInfoSetting } from '~/@pages/home/@widgets/InitialStudentInfoSetting/InitialStudentInfoSetting'

export const openB2GSignupPopup = () => {
  modalService.openModal(
    {
      content: <InitialStudentInfoSetting />,
    },
    {
      modalName: 'B2G_SIGNUP_MODAL',
      orderingNumber: 1,
      type: 'full',
    },
  )
}
